import store from '@/js/store';

const entity = (getter, paramName) => ({
    key: route => route.params[paramName],
    // Gated on the ids matching: a switch would otherwise report the previous entity's name.
    title: route => {
        const loaded = store.getters[getter];
        return loaded?._id === route.params[paramName] ? loaded.name : undefined;
    },
});

export const recordPromotionInShell = entity('promotions/selectedPromotion', 'promotionId');
export const recordSubCampaignInShell = entity('subCampaigns/selectedSubCampaign', 'subCampaignId');
